// extracted by mini-css-extract-plugin
export default {"projectsceleton":"SceletonProject_projectsceleton__DWkNK","shineForSkeleton-yhx2baozlun":"SceletonProject_shineForSkeleton-yhx2baozlun__ouzbH"};